<template>
  <svg
    :width="width ? width : height ? height * (131 / 33) : 131"
    :height="height ? height : width ? width * (33 / 131) : 33"
    viewBox="0 0 131 33"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      :fill="iconColor"
      fill-rule="evenodd"
    >
      <path d="M0 0v14.062h11.636c.117-.409.301-.786.555-1.112l-2.256-2.08.363-.393 2.257 2.08c.417-.384.934-.66 1.507-.786V0H0zM0 15.638V29.7h14.062V18.114a3.245 3.245 0 0 1-1.304-.605l-2.079 2.257-.395-.364 2.08-2.257a3.248 3.248 0 0 1-.784-1.507H0zM15.541 0v11.802c.445.113.858.306 1.21.581l2.079-2.256.394.363-2.08 2.257c.341.37.596.818.738 1.315h11.721V0H15.541zM30.885 20.564c-1.62-.877-3.478-1.315-5.578-1.315-1.668 0-2.944.224-3.827.673-.884.45-1.325 1.086-1.325 1.91 0 .814.426 1.391 1.278 1.736.754.309 2.032.499 3.837.573 1.544.062 2.588.124 3.132.185.988.099 1.779.278 2.371.537 1.31.569 1.965 1.563 1.965 2.984 0 1.36-.596 2.418-1.789 3.178-1.192.76-2.9 1.14-5.124 1.14-3.014 0-5.473-.66-7.376-1.983l.705-1.02a11.746 11.746 0 0 0 6.412 1.854c1.853 0 3.277-.274 4.272-.822.994-.548 1.491-1.308 1.491-2.28 0-.912-.45-1.565-1.353-1.959-.803-.357-2.168-.58-4.095-.666-1.421-.06-2.41-.123-2.965-.185-.927-.086-1.662-.235-2.205-.444-1.31-.495-1.965-1.39-1.965-2.687 0-1.211.562-2.16 1.687-2.845 1.124-.686 2.724-1.029 4.8-1.029 2.804 0 4.972.513 6.504 1.539l-.852.926zM50.51 31.85H37.482V18.433H49.99v1.149H38.686v4.577h7.858v1.15h-7.858V30.7H50.51zM64.575 25.197c.89 0 1.578-.246 2.066-.737.488-.491.733-1.184.733-2.08 0-1.865-1.082-2.798-3.244-2.798h-8.376v5.615h8.821zm.093-6.764c1.247 0 2.233.358 2.956 1.075.722.717 1.084 1.692 1.084 2.928 0 1.198-.39 2.15-1.168 2.853-.778.705-1.84 1.058-3.187 1.058h-8.599v5.503H54.55V18.433h10.118zM84.182 19.582h-6.413V31.85h-1.203V19.582h-6.413v-1.149h14.029zM87.165 31.85h1.205V18.433h-1.205zM111.386 31.85h-1.204V19.6h-.075l-7.43 9.562-7.45-9.562h-.056v12.25h-1.205V18.433h1.878l6.831 8.95 6.862-8.95h1.85zM126.709 27.217l-4.03-7.62h-.179l-4.053 7.62h8.262zm3.82 4.633h-1.382l-1.833-3.484h-9.475l-1.863 3.484h-1.384l7.098-13.417h1.779l7.06 13.417z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SeptimaLogo',
  props: {
    iconColor: {
      type: String,
      default: '#fff',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
